import PrivateRoute, { Router } from '@Components/app-layout/PrivateRoute';

import SubidsGridLayout from './containers/Grid';

export default function SubidLayout() {
  return <Router>
    <PrivateRoute path="/offer/allocations/:allocationID/subids" component={SubidsGridLayout} />
  </Router>
}
